import CrudCustom from '../../../libs/custom/CrudCustom';

let LogExportService = new CrudCustom('/log-exports');
export default LogExportService;
